/** @format */

import React, { useState } from "react";
import { Popover, Typography, Space, Radio } from "antd";
import { FaCopy, FaCheck } from "react-icons/fa6";
import { FaInfoCircle } from "react-icons/fa";

const { Paragraph } = Typography;

/**
 * A reusable component that displays position size with leverage options
 * @param {Object} props Component props
 * @param {number} props.positionSize The position size value
 * @param {number} props.stopLoss The stop loss value
 * @param {string} props.className Optional CSS class for styling
 * @param {number} props.suggestedLeverage
 * @returns {JSX.Element} The rendered component
 */
const PositionSizeLeverage = ({
  positionSize,
  stopLoss,
  className = "",
  suggestedLeverage = 1,
  isExpandedRow = false,
}) => {
  const [selectedLeverage, setSelectedLeverage] = useState(
    suggestedLeverage || 1,
  );

  const handleLeverageChange = (e) => {
    setSelectedLeverage(e.target.value);
  };

  // Calculate position size based on leverage
  const calculatedPositionSize = Math.min(
    ((1 / stopLoss) * 100) / selectedLeverage,
    100,
  )?.toFixed(2);

  const popoverContent = (
    <div style={{ maxWidth: "250px" }}>
      <Space direction="vertical" size="small">
        <Typography.Text strong>Select Leverage:</Typography.Text>
        <Radio.Group
          onChange={handleLeverageChange}
          value={selectedLeverage}
          optionType="button"
          buttonStyle="solid"
          style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}
        >
          {[1, 2, 3, 4, 5, 6, 7].map((leverage) => (
            <Radio.Button key={leverage} value={leverage}>
              {leverage}x
            </Radio.Button>
          ))}
        </Radio.Group>
        <div style={{ marginTop: "8px" }}>
          <Typography.Text strong>
            Position Size with {selectedLeverage}x:
          </Typography.Text>
          <Paragraph
            copyable={{
              text: calculatedPositionSize,
              icon: [
                <FaCopy color="#0C4CFC" key="copy-icon" />,
                <FaCheck color="green" key="copied-icon" />,
              ],
              tooltips: ["Copy", "Copied!"],
            }}
            style={{ marginBottom: 0 }}
          >
            <Typography.Text strong>{calculatedPositionSize}%</Typography.Text>
          </Paragraph>
        </div>
        {stopLoss && (
          <Typography.Text strong>
            Stop Loss: {Number(stopLoss).toFixed(2)}%
          </Typography.Text>
        )}
      </Space>
    </div>
  );

  if (!stopLoss) return null;

  return (
    <Popover content={popoverContent} title="Position Size with Leverage" trigger="click">
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        cursor: "pointer", 
        padding: isExpandedRow ? "1px 4px" : "2px 6px", 
        borderRadius: isExpandedRow ? "3px" : "4px", 
        backgroundColor: "#f0f0f0", 
        border: "1px solid #d9d9d9",
        fontSize: isExpandedRow ? "11px" : "12px",
        color: "#2A86FF"
      }}>
        <span style={{ marginRight: "4px" }}>{selectedLeverage}x</span>
        <FaInfoCircle style={{ fontSize: isExpandedRow ? "9px" : "10px" }} />
      </div>
    </Popover>

    // <div className={className}>
    //
    //   {/*<Paragraph*/}
    //   {/*	copyable={{*/}
    //   {/*		text: positionSize.toString(),*/}
    //   {/*		icon: [*/}
    //   {/*			<FaCopy color='#0C4CFC' key='copy-icon' />,*/}
    //   {/*			<FaCheck color='green' key='copied-icon' />,*/}
    //   {/*		],*/}
    //   {/*		tooltips: ["Copy", "Copied!"],*/}
    //   {/*	}}*/}
    //   {/*	style={{*/}
    //   {/*		marginBottom: 0,*/}
    //   {/*		display: "inline-flex",*/}
    //   {/*		alignItems: "center",*/}
    //   {/*	}}>*/}
    //   {/*	{Number(positionSize).toFixed(2)}%*/}
    //   {/*	<Popover*/}
    //   {/*		content={popoverContent}*/}
    //   {/*		title='Position Size with Leverage'*/}
    //   {/*		trigger='hover'*/}
    //   {/*		placement='right'>*/}
    //   {/*		<FaInfoCircle*/}
    //   {/*			style={{ marginLeft: "5px", cursor: "pointer", color: "#2A86FF" }}*/}
    //   {/*		/>*/}
    //   {/*	</Popover>*/}
    //   {/*</Paragraph>*/}
    // </div>
  );
};

export default PositionSizeLeverage;
